var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initPageCard = /* @__PURE__ */ __name(($el, $refs, pageHandle) => {
  const random_id = utils.shortUUID();
  const page = _pages[pageHandle] || utils.JSONParse(document.querySelector(`[data-page-data="${pageHandle}"]`)?.innerHTML);
  const state = window.Alpine.reactive({
    random_id,
    hydrated: true,
    ...page ?? {},
    url: page?.url ?? `/pages/${page?.handle}`
  });
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicText(content, state);
  }, "getDynamicText");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicText,
    getContentLabels
  };
}, "initPageCard");
const hydratePageCard = /* @__PURE__ */ __name(($el, card_handle, page_handle, page_id, classes = []) => {
  const hydratePageCardContent = /* @__PURE__ */ __name(() => {
    const node = document.querySelector(`[data-page-card='${card_handle}']`)?.cloneNode(true);
    if (!node && !$el.hasAttribute("data-intersected")) {
      $el.setAttribute("data-intersected", "true");
      const mo = new MutationObserver((mutation, obs) => {
        if ($el.hasAttribute("data-cards-loaded")) {
          $el.removeAttribute("data-intersected");
          const node2 = document.querySelector(`[data-page-card='${card_handle}']`)?.cloneNode(true);
          if (node2 && $el && $el.parentNode) {
            node2?.removeAttribute(`data-page-card`);
            node2?.setAttribute("data-page-handle", page_handle);
            node2?.setAttribute("data-page-id", page_id);
            node2.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
              el.remove();
            });
            node2.classList.add(...classes);
            $el.parentNode.replaceChild(node2, $el);
          }
          mo.disconnect();
          observer.disconnect();
        }
      });
      mo.observe($el, { attributes: true });
      return;
    }
    if (node && $el && $el.parentNode) {
      node?.removeAttribute(`data-page-card`);
      node?.setAttribute("data-page-handle", page_handle);
      node?.setAttribute("data-page-id", page_id);
      node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
        el.remove();
      });
      node.classList.add(...classes);
      $el.parentNode.replaceChild(node, $el);
    }
  }, "hydratePageCardContent");
  if ($el.hasAttribute("data-intersected")) {
    hydratePageCardContent();
    return;
  }
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        hydratePageCardContent();
        observer.disconnect();
      }
    },
    { rootMargin: "300px 300px 300px 300px" }
  );
  observer.observe($el);
}, "hydratePageCard");
window._sections["initPageCard"] = initPageCard;
window._sections["hydratePageCard"] = hydratePageCard;
